// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l5-1";
export var rowFirst = "_l5-3";
export var rowLast = "_l5-5";
export var rowMiddle = "_l5-4";
export var ticketListScroll = "_l5-2";
export var ticketStack = "_l5-0";